import {
  BillingFrequency,
  SeatOveragesBillingFrequency
} from 'common/drawers/PricingEditor/domain'

export const overagesFrequenciesOptions: {
  value: SeatOveragesBillingFrequency
  label: string
  description: string
}[] = [
  {
    value: 'MONTHLY',
    label: 'Monthly',
    description:
      'Overages will be charged at the end of every month where seats are added'
  },
  {
    value: 'QUARTERLY',
    label: 'Quarterly',
    description:
      'Overages will be charged at the end of every quarter where seats are added'
  },
  {
    value: 'HALF_YEARLY',
    label: 'Semi-annually',
    description:
      'Overages will be charged at the end of every half year where seats are added'
  },
  {
    value: 'YEARLY',
    label: 'Annually',
    description:
      'Overages will be charged at the end of every year where seats are added'
  }
]

export const frequencyOrder: Record<BillingFrequency, number> = {
  MONTHLY: 1,
  QUARTERLY: 2,
  HALF_YEARLY: 3,
  YEARLY: 4,
  ONE_TIME: 0,
  ON_DEMAND: 0,
  PER_EVENT: 0
}

export const getAvailableSeatOveragesFrequenciesFromSelectedPriceFrequency = (
  selectedPriceFrequency: BillingFrequency
) => {
  if (selectedPriceFrequency === 'MONTHLY') {
    return []
  }

  return overagesFrequenciesOptions.filter(({ value }) => {
    const overageFrequency = value as BillingFrequency
    return (
      frequencyOrder[overageFrequency] <= frequencyOrder[selectedPriceFrequency]
    )
  })
}

export const getNewOverageFrequencyForBillingFrequency = (params: {
  newBillingFrequency: BillingFrequency
  currentOveragesFrequency: SeatOveragesBillingFrequency | undefined
}) => {
  const newOveragesFrequencyOptions =
    getAvailableSeatOveragesFrequenciesFromSelectedPriceFrequency(
      params.newBillingFrequency
    )
  /**
   * If the new overage frequency is no longer present, it was a longer overage
   * period than the billing frequency. Therefore, we set it to the longest available
   * (at the end of the array).
   */
  return newOveragesFrequencyOptions.find(
    opt => opt.value === params.currentOveragesFrequency
  )
    ? params.currentOveragesFrequency
    : (newOveragesFrequencyOptions.at(-1)?.value ?? 'MONTHLY')
}
